export const panel = {
  content: {
    padding: '0',
    border: 'none',
  },
  header: {
    padding: '0',
    border: 'none',
  },
};
